/* eslint-disable no-multi-str */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useContext, useEffect } from 'react';
import ImageUploader from './common/UploadImage';
import { Editor } from '@tinymce/tinymce-react';
import Axios from 'axios';
import Input from './common/Input';
import { Badge, Form } from 'react-bootstrap';
import { XSquare } from 'react-bootstrap-icons';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from 'react-router-dom';

const SingleCourse = (props) => {

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);
    const [selectedImages, setSelectedImages] = useState([]);
    const [uploadButtonDisabled, setUploadButtonDisabled] = useState(true);
    const [statusOptions, setStatusOptions] = useState([{ value: 'active', name: 'Active' }, { value: 'inactive', name: 'Inactive' }]);
    const [content, setContent] = useState('');
    const [images, setImages] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    const fetchClient = () => {
        coreContext.fetchCourse(location, authContext.itemId);
    }

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({});

    useEffect(fetchClient, []);

    const populateClient = () => {
        setValue('title', coreContext.course.title);
        setValue('message', coreContext.course.message);
        setContent(coreContext.course.pageContent);
        setValue('edate', coreContext.course.bdate);
        setValue('cat', coreContext.course.bcategory);
        setImages(coreContext.course.blog_images);
    }

    useEffect(populateClient, [coreContext.course]);

    const deleteImage = (id) => {
        deleteCourseImage(id);
    }

    const deleteCourseImage = (id) => {
        Axios.post('/delete-course-image', { id }).then((response) => {
            const newImages = images.filter(image => image.id !== id);
            setImages(newImages);
        }).catch(err => { });
    }

    const renderImages = () => {
        if (images)
            return images.map(image => <div style={{ position: 'relative' }} key={image.id} className="col-md-6"><img style={{ padding: 5 }} className="img-fluid" src={`http://${image.url}`} alt='gallery image' /> <button onClick={() => deleteImage(image.id)} style={{ position: 'absolute', top: 0, left: 5 }} type="button" className="btn btn-danger btn-sm" title="Delete Image"> <XSquare size="12" /> </button></div>)
    }

    const onImagesUploadHandler = async () => {
        const count = selectedImages.length;
        let counter = 0;

        for await (const image of selectedImages) {
            ++counter;
            const formData = new FormData();
            formData.append('itemId', authContext.itemId);
            formData.append('courseId', coreContext.course.id);
            formData.append('image', image, image.name);
            formData.append('userId', authContext.userId);
            coreContext.uploadCourseImage(formData, authContext.itemId, coreContext.course.id);

            if (counter === count) {
                setTimeout(() => {
                    setSelectedImages([]);
                    coreContext.fetchCourseImages(authContext.itemId, coreContext.course.id);
                }, 2000);

                setTimeout(() => {
                    navigate('/courses');
                }, 5000);
            };
        }
    }

    const handleEditorChange = (content, editor) => {
        setContent(content);
    }

    const onCourseContentHandler = (data) => {
        coreContext.updateCourseContent(data.title, data.message, content, data.edate, data.cat, data.status, authContext.itemId, coreContext.course.id);
    }

    const onImagesSelected = (pictures) => {
        setSelectedImages(pictures);
        if (pictures.length > 0) setUploadButtonDisabled(false); else setUploadButtonDisabled(true);
    }

    return (<div className='container-fluid'>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">Edit Course</Badge></h3></div>
            <div className="card-body">
                <Form autoComplete='off' onSubmit={handleSubmit(onCourseContentHandler)} noValidate>
                    <Input label='Title' name='title' minLength={2} maxLength={155} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Title' />

                    <Input label='Image Message' name='message' minLength={2} maxLength={2000} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Message' />

                    <div className="row">
                        <div className="col-md-4">
                            <Input label='Course Date' name='edate' minLength={2} maxLength={50} required={true} register={register} errors={errors} elementType='date' placeholder='Enter Course Date' />
                        </div>
                        <div className="col-md-4">
                            <Input label='Course Category' name='cat' minLength={2} maxLength={50} required={true} register={register} errors={errors} elementType='text' placeholder='Enter Course Category : eg. CBSE or JEE or NEET' />
                        </div>
                        <div className="col-md-4">
                            <Input label='Status' name='status' required={true} register={register} errors={errors} elementType='select' options={statusOptions} />
                        </div>
                    </div>

                    <Editor
                        apiKey={coreContext.key}
                        value={content}
                        init={{
                            height: 500,
                            menubar: 'insert',
                            file_picker_types: 'file image media',
                            plugins: [
                                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                            ],
                            toolbar:
                                'undo redo | formatselect | bold italic backcolor forecolor  | fontsize fontfamily lineheight | \
         alignleft aligncenter alignright alignjustify | \
         bullist numlist outdent indent image | removeformat | code | help'
                        }}
                        onEditorChange={handleEditorChange}
                    />

                    <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp; {coreContext.renderLoader()}
                    <Input variant='danger' label={coreContext.message} elementType='label' />

                </Form>
            </div>
        </div>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">Upload Course Images</Badge></h3></div>
            <div className="card-title mx-auto">Best Image Size 500*333</div>
            <div className="card-body">
                <ImageUploader onImagesSelected={onImagesSelected} maxWidthOrHeight='500' pictures={selectedImages} />
                <Input value='Upload Images' onClick={onImagesUploadHandler} disabled={uploadButtonDisabled} elementType='button' variant='primary' />&nbsp;&nbsp; {coreContext.renderLoader()}
                <Input variant='danger' label={coreContext.message} elementType='label' />
            </div>
            <div className="card-body">
                <div className="card-title mx-auto"><h3><Badge variant="success">Course Images</Badge></h3></div>
                <div className="row">
                    {renderImages()}
                </div>
            </div>
        </div>
    </div>
    )
}

export { SingleCourse }
